import Model from '../Model';

export default class BuildModel extends Model {

	constructor(data) {
		super(data);
		this.build_name = data.name;
		this.build_number = data.build_number;
		this.artifact_count = data.artifact_count;
		this.url = data.url;
	}
}


// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/BuildModel.js